{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "HeroSlider",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "sliderId"
  ],
  "properties": {
    "sliderId": {
      "title": "Slider",
      "type": "string",
      "pattern": "^[0-9a-fA-F-]{36}$",
      "x-ui": "slider"
    }
  }
}
